import { memo, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import { Deposit } from '@/components/atoms/assets/Deposit'
import { Button } from '@/components/atoms/Button'

import { Routes } from '@/router/routes'

const DepositButtonComponent = () => {
  const { t } = useTranslation('common')
  const history = useHistory()

  const onClick = useCallback(() => {
    history.push(Routes.DEPOSIT)
  }, [history])

  return (
    <Button fill="outline" onClick={onClick}>
      <Deposit className="h-3 xs:h-4 mr-1" />
      <span className="text-xxs xs:text-xs">{t('wallet.deposit')}</span>
    </Button>
  )
}

export const DepositButton = memo(DepositButtonComponent)
